import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import MainContainer from 'src/components/common/MainContainer';
import { SectionErrorBoundary } from 'src/components/ErrorBoundary/SectionErrorBoundary';
import TabComponent from 'src/components/Tab/TabComponent';
import { ReportTabKey, TABS_REPORT } from 'src/features/AiReport/config';
import TradeDataReport from 'src/features/AiReport/TradeDataReport';
import { useQueryParams } from 'src/hooks/useQueryParam';
import MainLayout from 'src/layouts';

const AiReport = () => {
  const { tab } = useQueryParams();
  const selectedTab = useMemo(() => tab ?? ReportTabKey.TRADE_DATA, [tab]);
  const [, setSearchParams] = useSearchParams();

  const renderForm = () => {
    switch (selectedTab) {
      case ReportTabKey.TRADE_DATA:
        return <TradeDataReport />;
      default:
        return <TradeDataReport />;
    }
  };

  return (
    <MainLayout>
      <MainContainer>
        <TabComponent
          tabs={TABS_REPORT}
          selected={selectedTab}
          handleChange={(_, value) => {
            setSearchParams((searchParams) => {
              searchParams.set('tab', value);
              return searchParams;
            });
          }}
        />
        <Box mt={2} />
        <SectionErrorBoundary resetKey={selectedTab} sectionName={`AiReport-${selectedTab}`}>
          {renderForm()}
        </SectionErrorBoundary>
      </MainContainer>
    </MainLayout>
  );
};

export default AiReport;
